<template>
  <el-row
    class="row-bg"
    style="height:100%;position:relative;"
    :gutter=1
  >
    <el-col
      :span="8"
      style="height:100%"
    >
      <div :style="titleStyle">身份列表</div>
      <div :style="bodyStyle">
        <el-tree
          lazy
          :load="loadNavTree"
          @node-click="handleNav"
          style="height:100%;overflow:auto;"
          :props="defaultTreeProps"
          :expand-on-click-node="false"
        />
      </div>
    </el-col>
    <el-col
      :span="8"
      style="height:100%"
    >
      <div :style="titleStyle">身份明细</div>
      <div :style="bodyStyle">
        <el-tree
          lazy
          :load="null"
          @node-click="handleDetail"
          ref="detailTree"
          show-checkbox
          style="height:100%;overflow:auto;"
          :default-expanded-keys="detailTreeDefaultExpanedKeys"
          :node-key="USEDID"
          :props="defaultTreeProps"
          :expand-on-click-node="false"
          check-on-click-node
          @check-change="handleDetailTreeCheckChange"
          :default-checked-keys="detailTreeDefaultCheckKeys"
          :filter-node-method="filterNodeMethod"
        />
      </div>
    </el-col>
    <el-col
      :span="8"
      style="height:100%"
    >
      <div :style="titleStyle">已选身份</div>
      <div :style="bodyStyle">
        <el-tree
          :data="value"
          :renderContent="renderContent"
          style="height:100%;overflow:auto;"
        ></el-tree>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import api from "@/common/api/maintain";
export const USEDID = "useIdByThisPage";
/**
 * 比较的时候你就看objId和identityId两个有没有一个相同的，只要两个中有一个相同中间面板就过滤掉。  授权的时候我们给后台提交的话用户就传objId，其他就传identityId
 * U ：用户  D：部门  R：角色 G：群组
 */
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      titleStyle:
        "height: 30px;line-height:30px;background:#eee;padding:0 5px;",
      bodyStyle:
        "border-top:30px solid transparent;margin-top:-30px;height:100%;",
      detailTreeDefaultExpanedKeys: [],
      defaultTreeProps: {
        children: "children",
        label: "label",
        disabled: "disabled",
        isLeaf: "isLeaf"
      },
      pendingSelectionChange: [],
      applySelectionChangeTimeout: null,
      USEDID
    };
  },

  computed: {
    detailTreeDefaultCheckKeys() {
      return this.value.map(x => x[USEDID]);
    }
  },

  methods: {
    async loadNavTree(node, resolver) {
      const params = {
        id: "",
        type: ""
      };

      if (node.level === 0) {
        params.id = "#root";
        params.type = "#root";
      } else if (node.data) {
        params.id = node.data.id;
        params.type = node.data.type;
      }

      const { result } = await api.listOrgRes(params);
      let type = params.type;
      let path = "";
      let isLeaf = false;
      resolver(
        this.trimDuplicatedBy(
          result.map(({ name, ...rest }) => {
            if (node.level === 0) {
              type = rest.id;
            }

            if (node.level > 0) {
              switch (type) {
                case "#roles":
                default: {
                  isLeaf = rest.leaf === true || rest.hasChild === 0;
                }
              }
            }
            return {
              label: name,
              name,
              type,
              isLeaf,
              ...rest
            };
          }),
          "id"
        )
      );
    },

    handleNav(data, node, comp) {
      this.selectedNav = data;
      this.$refs.detailTree.store.load = async (node, resolver) => {
        let result = [];
        if (node.data && node.data.children && $.isArray(node.data.children)) {
          result = node.data.children.map(x => {
            let idKey ="objId";
            if (!x[idKey]) idKey = "id";
            return {
              ...x,
              isLeaf: true,
              type: data.type,
              [USEDID]: x[idKey]
            };
          });
        } else {
          const params = {
            id: ((node && node.data) || {}).id || data.id,
            type: data.type,
            path: data.name
          };
          result = (await api.listOrgDetail(params)).result.map(x => {
            let idKey = "objId";
            if (!x[idKey]) idKey = "id";

            return {
              ...x,
              [USEDID]: x[idKey],
              isLeaf: x.leaf !== false
            };
          });
        }

        this.detailTreeDefaultExpanedKeys.length = 0;
        this.detailTreeDefaultExpanedKeys = result.filter(x => {
          if (x.children) return x[USEDID];
        });
        resolver(
          this.trimDuplicatedBy(
            result.map(({ name, ...rest }) => {
              return {
                label: name,
                name,
                ...rest
              };
            }),
            "id"
          )
        );

        this.$nextTick(() => {
          this.$refs.detailTree.filter();
        });
      };
      this.$refs.detailTree.store.root.loaded = false;
      this.$refs.detailTree.store.root.loading = false;
      this.$refs.detailTree.store.root.childNodes = [];

      this.$refs.detailTree.store.root.loadData();
    },

    handleDetail(data, node, comp) {},

    handleDetailTreeCheckChange(data, checked) {
      if (data && data.children) return;

      this.pendingSelectionChange.push([data, checked]);

      clearTimeout(this.applySelectionChangeTimeout);
      this.applySelectionChangeTimeout = setTimeout(this.applySelectionChange);
    },

    filterNodeMethod(value, data, node) {
      if (data && data.children) return true;
      if (this.value.some(x => x.id === data[USEDID])) {
        return false;
      }
      return true;
    },

    applySelectionChange() {
      let value = [...this.value];
      for (let i = 0; i < this.pendingSelectionChange.length; i++) {
        const [data, checked] = this.pendingSelectionChange[i];
        if (checked) {
          value.push(data);
        } else {
          value = value.filter(x => x[USEDID] !== data[USEDID]);
        }
      }
      this.$emit("input", value);
      this.pendingSelectionChange.length = 0;
      setTimeout(() => {
        this.$refs.detailTree.filter();
      }, 100);
    },

    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node" style="width:100%;">
          <span style="display:table-cell;width:100%;">{node.label}</span>
          <span style="display:table-cell;padding:0 8px;">
            <el-button
              type="text"
              class="be-text"
              on-click={() => this.remove(node, data)}
            >
              <i class="el-icon el-icon-close" />
            </el-button>
          </span>
        </span>
      );
    },

    remove(node, data) {
      this.$emit("input", this.value.filter(x => x[USEDID] !== data[USEDID]));
      this.$nextTick(() => {
        this.$refs.detailTree.setCheckedKeys(this.detailTreeDefaultCheckKeys);
        this.$refs.detailTree.filter();
      });
    },

    trimDuplicatedBy(array, field) {
      const footprints = {};
      for (let i = 0; i < array.length; ) {
        const item = array[i];
        if (item[field] in footprints) {
          array.splice(i, 1);
        } else {
          footprints[item[field]] = true;
          i++;
        }
      }
      return array;
    }
  },

  watch: {
    value(value) {
      for (let i = 0; value && i < value.length; i++) {
        if (value[i] && !(USEDID in value[i])) {
          value[i][USEDID] = value[i].id;
        }
      }
      this.$refs.detailTree.filter();
      this.$refs.detailTree.setCheckedKeys([]);
    }
  }
};
</script>

<style>
.el-button.be-text:focus,
.el-button.be-text:hover {
  color: #66b1ff;
  border-color: transparent;
  background-color: transparent;
}
.el-button--text.be-text {
  color: #409eff;
  background: 0 0;
  padding-left: 0;
  padding-right: 0;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/authorityEditor.vue